<template>
  <div class="card">
    <h1>{{ __('Glömt lösenord') }}</h1>
    <p class="fix-width margin-bottom-x1">
      {{
        __(
          'Ange e-postadress så skickar vi instruktioner om hur du återställer ditt lösenord.'
        )
      }}
    </p>
    <input type="email" v-model="$v.email.$model" :placeholder="__('E-post')" />

    <div class="fix-width text-small margin-bottom-x3">
      {{
        __('Om du fortfarande behöver hjälp kontaktar du Equardians support.')
      }}
    </div>

    <el-message warning class="margin-bottom-x2" v-if="warningMessage">
      {{ warningMessage }}
    </el-message>
    <el-message warning class="margin-bottom-x2" v-if="errorMessage">
      {{ errorMessage }}
    </el-message>
    <el-message info class="margin-bottom-x2" v-if="infoMessage">
      {{ infoMessage }}
    </el-message>

    <div class="row">
      <button @click="() => $router.go(-1)" class="button button-snd">
        {{ __('Tillbaka') }}
      </button>

      <button :disabled="$v.$invalid" @click="forgotEmail()" class="button">
        {{ __('Återställ lösenord') }}
      </button>
    </div>
    <el-loader margin-top v-if="isLoading" />
  </div>
</template>
<script>
import auth from 'services/auth.js'
import { required, email } from 'vuelidate/lib/validators'

import logScope from 'log-scope'
const log = logScope('ResetPassword')

export default {
  data () {
    return {
      email: '',
      warningMessage: '',
      infoMessage: '',
      errorMessage: '',
      isLoading: false,
    }
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  methods: {
    reset () {
      this.warningMessage = ''
      this.infoMessage = ''
      this.errorMessage = ''
    },
    async forgotEmail () {
      this.reset()

      if (this.email === '') {
        this.warningMessage = this.__('Vänligen ange e-post')
        return
      }

      this.isLoading = true

      try {
        await auth.sendPasswordResetEmail(this.email)
        this.infoMessage = this.__('Email har skickats.')
      } catch (err) {
        log.error('Could not reset email')
        this.errorMessage = this.__('Kunde inte skicka email.')
      }

      this.isLoading = false
    },
  },
}
</script>
